import { Image } from "../Section/Section";
import { useContext } from "react";
import { BNBox, BNButton } from "@bn-monorepo/js-packages";
import { ButtonOwnProps } from "@mui/material";
import { Link } from "react-router";
import { SettingsContext } from "../../../../../settingsContext";

export interface IButton {
  text: string;
  textAlign: "inherit" | "left" | "center" | "right" | null;
  href: string;
  type:
    | "red"
    | "blue"
    | "white"
    | "green"
    | "image"
    | "icon"
    | "icon-full-width"
    | "next-section"
    | "next-section-white"
    | "get-app";
  isSpa: boolean;
  image?: Image;
  target?: string;
  onClick?: () => void;
}

const Button: ReactFCWithNoJs<IButton> = ({ text, textAlign, href: hrefRaw, type, isSpa, onClick }) => {
  const { resolveUrl } = useContext(SettingsContext);
  const href = resolveUrl(hrefRaw);
  const { color, variant } = MapBNButtonPropsByUmbracoButton(type);
  return (
    <BNBox
      sx={{
        textAlign: textAlign || "center",
        my: 1,
        px: 3,
      }}
    >
      <BNButton
        sx={{
          textAlign: textAlign,
          minHeight: "5rem",
          px: 4,
          fontSize: "1.6rem !important",
          maxWidth: "100%",
        }}
        href={isSpa ? undefined : href}
        to={isSpa ? href : undefined}
        component={isSpa ? Link : undefined}
        color={color}
        variant={variant}
        size="large"
        onClick={onClick}
      >
        {text}
      </BNButton>
    </BNBox>
  );
};
Button.noJsRequired = true;
export default Button;

function MapBNButtonPropsByUmbracoButton(type: IButton["type"]): {
  color?: ButtonOwnProps["color"];
  variant?: ButtonOwnProps["variant"];
} {
  switch (type) {
    case "red":
    case "green":
    case "image":
    case "icon":
    case "icon-full-width":
    case "next-section":
      return { color: "primary" };
    case "blue":
      return {
        color: "secondary",
      };
    case "white":
    case "next-section-white":
      return {
        color: undefined,
        variant: "outlined",
      };
  }
  return {};
}
